import { render, staticRenderFns } from "./HO225Fields.vue?vue&type=template&id=2a15cb80"
import script from "./HO225Fields.vue?vue&type=script&lang=ts"
export * from "./HO225Fields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports